import { Alert } from '@mui/material';
import { JSX } from 'react';

/**
 * Warning message for sections that are not included in the report
 */
const EmptySectionWarning = (): JSX.Element => (
  <Alert severity="error">Report does not include this section</Alert>
);

export default EmptySectionWarning;
